import React, { useState, useRef } from "react";
import { css } from "glamor";
import { propMerge } from "glamor/react";
import ClientOnly from "../../utils/ClientOnly";


const Image = ({
    alt,
    image,
    retinaReady,
    ...otherProps
}) => {
    const [hasLoaded, setHasLoaded] = useState(false)
    const [naturalSize, setNaturalSize] = useState({
        width: "100%",
        height: "100%",
    })
    const imageRef = useRef(null)

    const handleLoad = () => {
        const denominator = retinaReady ? 2 : 1;

        setNaturalSize({
            height: imageRef.current.naturalHeight / denominator,
            width: imageRef.current.naturalWidth / denominator,
        })
        setHasLoaded(true)
    }

    const styles = css({
        opacity: hasLoaded ? 1 : 0,
        transform: hasLoaded ? "translateY(0)" : "translateY(20px)",
        maxHeight: naturalSize.height,
        maxWidth: naturalSize.width,
        transition: `transform ${300}ms linear ${0}ms, opacity ${300}ms linear ${0}ms`
    })

    return (
        <ClientOnly>
            <img
                ref={imageRef}
                alt={alt}
                src={image}
                onLoad={handleLoad}
                {...propMerge(styles, otherProps)}
            />
        </ClientOnly>
    )

}

export default Image